import React from 'react';
import styled from '@emotion/styled';
import { ColourRampType } from '../../types/dataTypes';

type ColourRampProps = {
  attributeName: string;
  colourRamp: ColourRampType | undefined;
};

function ColourRamp({ attributeName, colourRamp } : ColourRampProps){
  return (
    <ColourRampContainer>
      <AttributeName>{attributeName}</AttributeName>
      <ColourRampItems>
        {colourRamp && colourRamp.map((stop) => (
          <ColourRampItem key={stop.value}>
            <ColourSquare style={{ backgroundColor: stop.colour }} />
            <ValueLabel>{stop.value}</ValueLabel>
          </ColourRampItem>
        ))}
      </ColourRampItems>
    </ColourRampContainer>
  );
};

export default ColourRamp;

const ColourRampContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const AttributeName = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const ColourRampItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const ColourRampItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const ColourSquare = styled.div`
  width: 20px;
  height: 20px;
`;

const ValueLabel = styled.div`
  font-size: 12px;
`;